var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"mt-2 text-xs md:text-sm",attrs:{"type":_vm.buttonLicenseType,"icon":"shop"},on:{"click":function($event){return _vm.$router.push(_vm.buyLink)}}},[_vm._v(" "+_vm._s(_vm.licenseButtonTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }